export default {

	async init () {

	},

	// User session
	async control_user_login () {

		Anvil.setSpinner('Bejelentkezés')

		// See if we have a previous session
		if (Anvil.session.user_auth) {

			// Go to home page
			await Anvil.exec('main/action_home')
			return
		}

		// Otherwise, go to login page and request user credentials
		await Anvil.route('/login', 'redirect')
	},

	async page_login ({ account_name = null }) {

		// See if we have a previous session
		if (Anvil.session.user_auth) {
			await Anvil.route('/home', 'redirect')
			return
		}

		const remember_me = Anvil.store.auth_remember_me
		if (account_name === null && remember_me === true) account_name = Anvil.store.auth_account_name
		if (account_name === null) account_name = ''

		await Anvil.renderPage('/auth/page_login', {
			login_credentials: new Anvil.models.auth.LoginCredentials({
				account_name,
				password: '',
				remember_me: (remember_me === true ? 1 : 0)
			})
		})
	},

	async action_login (form_data) {

		Anvil.setSpinner('Bejelentkezés')

		// Validation
		if (!form_data.record.validate()) return

		// Save "remember me" preferences to persistent store
		if (form_data.remember_me == 1) {
			Anvil.store.auth_remember_me = true
			Anvil.store.auth_account_name = form_data.account_name
		} else {
			Anvil.store.auth_remember_me = false
			Anvil.store.auth_account_name = null
		}

		// Attempt login
		try {
			var res = await Anvil.REST.post('/auth/login', {
				account_name: form_data.account_name,
				password: form_data.password
			})
		} catch (err) {
			if (err.name == 'ValidationError') {
				// Server-side validation
				for (let validation_error of err.validation_messages) {
					form_data.record.setErrors(validation_error.field, validation_error.message)
				}
			} else {
				// Other error
				Anvil.toast.warning('Sikertelen bejelentkezés', err.message)
			}

			// The account name or password was wrong
			Anvil.session.access_token = null
			Anvil.session.user_auth = false
			Anvil.session.user = null

			$('#login_password').focus()
			return
		}

		// Login was successful
		Anvil.session.access_token = res.access_token
		Anvil.session.user_auth = true
		Anvil.session.user = res.user

		// Go to home page
		await Anvil.exec('main/action_home')

		Anvil.toast.success('Üdvözöljük!', 'Bejelentkezés sikeres')
	},

	async action_logout (passive = false) {

		// Tell the server to clean up the session (but we don't care)
		try {
			if (!passive) await Anvil.REST.delete('/auth/session')
		} catch (err) {}

		// Logout is always successful
		Anvil.session.access_token = null
		Anvil.session.user_auth = false
		Anvil.session.user = null

		await Anvil.route('login')
		if (!passive) Anvil.toast.success('Viszontlátásra!', 'Kijelentkezés sikeres')
	},

	async page_forgotten_password () {

		var account_name = ''
		const remember_me = Anvil.store.auth_remember_me
		if (remember_me === true) account_name = Anvil.store.auth_account_name
		if (account_name === null) account_name = ''

		await Anvil.renderPage('/auth/page_forgotten_password', {
			form_data: new Anvil.models.Record({ account_name })
		})
	},

	async action_forgotten_password (form_data) {

		// Attempt request
		try {
			await Anvil.REST.post('/v1/students/password-reset-request', form_data.record.getObject())
		} catch (err) {
			if (err.name == 'ValidationError') {
				// Server-side validation
				for (let validation_error of err.validation_messages) {
					form_data.record.setErrors(validation_error.field, validation_error.message)
				}
			} else {
				// Other error
				Anvil.toast.warning('Sikertelen művelet', err.message)
			}

			$('#password_reset_account_name').focus()
			return
		}

		Anvil.toast.success('Sikeres művelet', 'A jelszó megújító e-mailt elküldtük.')
	},

	async page_password_reset ({ token }) {

		await Anvil.renderPage('/auth/page_password_reset', {
			form_data: new Anvil.models.Record({
				token,
				password: '',
				confirm_password: ''
			})
		})
	},

	async action_password_reset (form_data) {

		// Attempt request
		try {
			await Anvil.REST.post('/v1/students/password-reset', form_data.record.getObject())
		} catch (err) {
			if (err.name == 'ValidationError') {
				// Server-side validation
				for (let validation_error of err.validation_messages) {
					form_data.record.setErrors(validation_error.field, validation_error.message)

					// Bad token
					if (validation_error.field == 'token') {
						Anvil.toast.warning('Hibás azonosító', 'A jelszó megújító kulcs már fel lett használva, vagy lejárt.')
					}
				}
			} else {
				// Other error
				Anvil.toast.warning('Sikertelen művelet', err.message)
			}

			$('#password_reset_password').focus()
			return
		}

		await Anvil.exec('main/action_home')
		Anvil.toast.success('Sikeres művelet', 'A jelszó megújítása sikeres.')
	},

	// Register account
	async page_register () {

		let register_form_data = new Anvil.models.auth.RegisterFormData()

		await Anvil.renderPage('/auth/page_register', { register_form_data })
	},

	async action_register () {

		Anvil.setSpinner('Regisztráció')

		let form_data = Anvil.page.register_form_data

		// Validation
		if (!form_data.record.validate()) return

		// Attempt registration
		try {
			var res = await Anvil.REST.post('/auth/register', form_data.record.getObject())
		} catch (err) {
			if (err.name == 'ValidationError') {
				// Server-side validation
				for (let validation_error of err.validation_messages) {
					form_data.record.setErrors(validation_error.field, validation_error.message)
				}
			} else {
				// Other error
				Anvil.toast.warning('Sikertelen regisztráció', err.message)
			}

			return
		}

		// Display the login page
		await Anvil.route(Anvil.href('/login', { account_name: res.account_name }))

		// Show the registration success modal
		Anvil.toast.success('Sikeres regisztráció', 'A fiókot sikeresen létrehoztuk.')
	}
}
